import { themr } from '@friendsofreactjs/react-css-themr';
import { compose } from 'recompose';

import DeviationNotifications from './DeviationNotifications';
import intlEquipped from '../../hocs/intlEquipped';

export default compose(
    intlEquipped,
    themr('DeviationNotifications')
)(DeviationNotifications);
